import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function ContactBanner() {
  return <section className="w-full py-16 px-4 text-center" style={{
    backgroundColor: '#2DA5A0'
  }} id="contact" aria-label="Contact us" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        {/* Headline */}
        <h2 className="font-bold text-4xl text-white" data-id="element-3">Ready to Get Started?</h2>

        {/* Subheadline */}
        <p className="text-base mt-3 mb-10 max-w-xl mx-auto leading-relaxed" style={{
        color: 'rgba(255,255,255,0.9)'
      }} data-id="element-4">
          Contact us today for a free quote. Our support team is available 24/7
          by phone, email, or text.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center" data-id="element-5">
          <a href="tel:+12016778496" className="w-full sm:w-auto min-h-[52px] flex items-center justify-center gap-2 font-bold rounded-lg px-8 py-3 text-base transition-opacity hover:opacity-90" style={{
          backgroundColor: '#ffffff',
          color: '#2DA5A0'
        }} data-id="element-6">
            <PhoneIcon className="w-5 h-5" aria-hidden="true" data-id="element-7" />
            Call (201) 677-8496
          </a>
          <a href="#" className="w-full sm:w-auto min-h-[52px] flex items-center justify-center font-bold rounded-lg px-8 py-3 text-base text-white transition-opacity hover:opacity-90" style={{
          backgroundColor: '#C8962E'
        }} data-id="element-8">
            Request a Quote
          </a>
        </div>
      </div>
    </section>;
}